import React from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { useLocation } from "react-router-dom";

export default function OndeEstou() {
    const location = useLocation();

    // Função para dividir o caminho da URL em itens de breadcrumb
    const createBreadcrumbItems = () => {
        const pathnames = location.pathname.split('/').filter(x => x);
        const items = pathnames.map((path, index) => {
            const local = path.charAt(0).toUpperCase() + path.slice(1);
            return {
                label: <>Você está em: <span className='last-item'>{local.toLowerCase()}</span></>, // Exibe a primeira letra maiúscula
            };
        });
    
        return items;
    };
    

    const items = createBreadcrumbItems(); // Gerando os itens dinamicamente
    const home = { icon: 'pi pi-home', }; // Ícone de home

    return (
        <BreadCrumb disbled model={items} home={home} className="custom-breadcrumb"  style={{border: 'none', fontSize: '14px', paddingTop: '8px', paddingBottom: '8px'}} />
    );
}
